/* eslint-disable quotes */
import elementLocalePl from 'element-ui/lib/locale/lang/pl'
import elementLocaleEn from 'element-ui/lib/locale/lang/en'
import elementLocaleEs from 'element-ui/lib/locale/lang/es'

const messages = {
  en: {
    'Create': 'Create',
    'Cancel': 'Cancel',

    'email': 'email',
    'username': 'username',
    'password': 'password',
    'reset': 'reset',
    'submit': 'submit form',
    'Name': 'Name',
    'Thumbnail': 'Thumbnail',
    'File': 'File',
    'Content': 'Content',
    'Operations': 'Operations',
    'No data': 'No data',
    'Original file name:': 'Original file name:',
    'Original file hash:': 'Original file hash:',
    'Original file size:': 'Original file size:',
    'Original file MIME:': 'Original file MIME:',
    'Created at:': 'Created at:',
    'Update at:': 'Update at:',

    'User list': 'User list',
    'Nick': 'Nick',
    'Email': 'Email',
    'Password': 'Password',
    'Retype password': 'Retype password',
    'Client': 'Client',
    'Roles': 'Roles',
    'Edit user': 'Edit user',
    'Add new user account': 'Add new user account',
    'Edit user account': 'Edit user account',
    'Delete user account': 'Delete user account',
    'Please enter nick name': 'Please enter nick name',
    'Length should be 3 to 255': 'Length should be 3 to 255',
    'Please enter email': 'Please enter email',
    'Email should be valid address': 'Email should be valid address',
    'Please select a client': 'Please select a client',
    'Please select assigned roles': 'Please select assigned roles',
    'Please input the password': 'Please input the password',
    'Please input the password again': 'Please input the password again',
    'Two inputs don\'t match!': 'Two inputs don\'t match!',
    'shortMonday': 'Mon',
    'shortTuesday': 'Tue',
    'shortWednesday': 'Wed',
    'shortThursday': 'Thu',
    'shortFriday': 'Fri',
    'shortSaturday': 'Sat',
    'shortSunday': 'Sun',
    'shortestMonday': 'M',
    'shortestTuesday': 'T',
    'shortestWednesday': 'W',
    'shortestThursday': 'T',
    'shortestFriday': 'F',
    'shortestSaturday': 'S',
    'shortestSunday': 'S',
    ...elementLocaleEn
  },
  pl: {
    "Edit Play Period Set": "Edycja zestaw okresów działania",
    "Add Play Period Set": "Dodaj zestaw okresów działania",
    "shortMonday": "Pon",
    "shortTuesday": "Wto",
    "shortWednesday": "Śro",
    "shortThursday": "Czw",
    "shortFriday": "Pią",
    "shortSaturday": "Sob",
    "shortSunday": "Nie",
    "shortestMonday": "P",
    "shortestTuesday": "W",
    "shortestWednesday": "Ś",
    "shortestThursday": "C",
    "shortestFriday": "P",
    "shortestSaturday": "S",
    "shortestSunday": "N",
    "Monday": "Poniedziałek",
    "Tuesday": "Wtorek",
    "Wednesday": "Środa",
    "Thursday": "Czwartek",
    "Friday": "Piątek",
    "Saturday": "Sobota",
    "Sunday": "Niedziela",
    "Add new or upgrade an Extension": "Dodaj nową lub zaktualizuj wtyczkę",
    "Name": "Nazwa",
    "name": "nazwa",
    "Name (at least 3 characters)": "Nazwa (minimum 3 znaki)",
    "Description": "Opis",
    "description": "opis",
    "Version": "Wersja",
    "version": "wersja",
    "Playlist": "Playlista",
    "yes": "tak",
    "no": "nie",
    "Scope": "Zasięg",
    "global": "globalna",
    "local": "lokalna",
    "browse": "przeglądaj",
    "select .zip with schema.json and index.dist.js": "plik .zip a w nim schema.json oraz index.dist.js",
    "uploading extension...": "wgrywam wtyczkę",
    "upload": "wgraj na serwer",
    "uploading": "wysyłanie",
    "Could not parse .zip file": "Nie można zaakceptować pliku .zip",
    "Some extensions found with similar name. If you want to upgrade an extension, please click on one of them. Remember to adjust version afterwards.": "Znaleziono wtyczki z podobnymi nazwami. Jeśli chcesz zaktualizować wtyczkę, wybierz ją z listy poniżej. Nadaj jej potem odpowiednią wersję.",
    "Global/Network": "Globalne/Sieć",
    "Delete Unused Extensions": "Usuń nieużywane wtyczki",
    "Unused extensions.": "Nieużywane wtyczki.",
    " selected": " wybrane",
    "All extensions are in use :)": "Wszystkie wtyczki są w użyciu :)",
    "Extensions": "Wtyczki",
    "delete": "usuń",
    "Playitem override defaults": "Playitem override defaults",
    "Extension defaults": "Wartości domyślne wtyczki",
    "Save": "Zapisz",
    "saving...": "zapisywanie...",
    "Filter by media type": "Filtruj po typie medium",
    "Layout:": "Układ mediów",
    "Width:": "Szerokość",
    "Height:": "Wysokość",
    "rendering layout": "renderowanie",
    "Snap to borders:": "Przyciągaj do krawędzi obrazu",
    "Snap distance px:": "Przyciągaj od odległości",
    "Show guides:": "Pokaż linie pomocnicze",
    "Dim not selected:": "Przyciemnij niewybrane",
    "High quality preview:": "Podgląd wysokiej jakości",
    "|": "|",
    "Play Properties": "Właściwości wyświetlania",
    "Synchronization": "Synchronizacja",
    "Exceptions for players": "Wyjątki na ekranach",
    "Save exceptions": "Zapisz wyjątki",
    "Library root folder": "Główny katalog biblioteki",
    "back": "wstecz",
    " zones": " strefy",
    "Updated": "Zaktualizowane",
    "Created": "Utworzone",
    "Modified": "Zmodyfikowane",
    " elements": " elementów",
    "Create folder": "Utwórz folder",
    "Folder name:": "Nazwa folderu",
    "Create": "Utwórz",
    "generating": "generowanie",
    "Medium name": "Nazwa medium",
    "Muted": "Wyciszone",
    "save": "zapisz",
    "Untest": "Odtestuj",
    "Un-test medium": "Odtestuj medium",
    "Info": "Info",
    "Tags": "Tagi",
    "Appearances": "Wystąpienia",
    "Configure": "Konfiguruj",
    "Sort": "Sortuj",
    "Editors": "Edytorzy",
    "Playlist items:": "Elementy playlisty",
    "Playlist duration:": "Czas trwania playlisty",
    "Created:": "Utworzono:",
    "Video duration:": "Czas trwania filmu:",
    "Framerate:": "Klatki na sekundę:",
    "Bitrate:": "Bity na seknundę:",
    "File size:": "Rozmiar pliku:",
    "Converted:": "Skonwertowany:",
    "Mime type:": "Typ mime:",
    "Audio duration:": "Czas trwania audio:",
    "Checksum:": "Suma kontrolna:",
    "Extension:": "Wtyczka:",
    "Pick a medium in left panel": "Wybierz medium w lewym panelu",
    "elements": "elementów",
    "Previously edited media": "Poprzednio edytowane media",
    "Options": "Opcje",
    "Edit medium": "Edytuj",
    "Local Playlist of ": "Lokalna playlista ",
    "Only selected users can edit medium": "Tylko wybrani użytkownicy mogą edytować medium",
    "Medium can be edited by anyone": "Każdy może edytować medium",
    "Medium editors:": "Edytorzy",
    "This medium has no editors, and can be edited by anyone.": "To medium nie ma przypisanych edytorów, więc może być edytowane przez każdego.",
    "Click on users below to limit editing permission to selected users.": "Kliknij w użytkownika poniżej, aby ograniczyć możliwość edycji medium do wybranych użytkowników.",
    "Medium Appearances": "Wystąpienia medium",
    "Screens": "Ekrany",
    "Screen": "Ekran",
    "Playlists": "Playlisty",
    "Library": "Biblioteka",
    "List": "Lista",
    "Images": "Grafiki",
    "Videos": "Filmy",
    "Layouts": "Układy",
    "Unassigned": "Nieprzypisane",
    "No Appearances": "Brak wystąpień",
    "This medium has no tags.": "Medium nie ma tagów.",
    " Click a tag below to assign it to medium": "Kliknij na tag poniżej aby go przypisać do medium",
    "No network tags.": "Brak tagów w sieci.",
    "+ Create Tag": "+ Utwórz tag",
    "Change Tag in Network": "Zmień tag w całej sieci",
    "Change tag text": "Zmień tekst taga",
    "deleting...": "usuwanie...",
    "Delete tag from network": "Usuń tag z sieci",
    "Toggle Tag Filter": "Przełącz filtr tagów",
    "Reload": "Przeładuj",
    "Playlist was changed by other user. Click to reload.": "Playlista została zmieniona przez innego użytkownika. Kliknij aby przeładować.",
    "Reload playlist": "Przeładuj playlistę",
    "Normal view": "Widok normalny",
    "Compact view": "Widok kompaktowy",
    "Show restrictions": "Pokaż restrykcje",
    "Close restrictions": "Ukryj restrykcje",
    "Display Properties": "Właściwości wyświetlania",
    "Time restrictions": "Ograniczenia czasowe",
    "Rendering playlist content": "Renderowanie zawartości playlisty",
    "Zone properties": "Właściwości strefy",
    "Exceptions": "Wyjątki",
    "Duration:": "Czas trwania",
    "Natural": "Naturalny",
    "Forced": "Wymuszony",
    "natural duration": "naturalny czas trwania",
    "Forced duration:": "Wymuszony czas trwania:",
    "After end:": "Po zakończeniu",
    "(if forced duration is longer than natural)": "(jeśli wymuszony czas trwania jest dłuższy niż naturalny)",
    "Loop": "Zapętl",
    "Stop": "Zatrzymaj",
    " of silence": " ciszy",
    " of transparency": " przeźroczystości",
    "loop": "zapętl",
    " times": " razy",
    "Other layout content:": "Pozostała zawartość układu:",
    "Play": "Graj",
    "Pause": "Wstrzymaj",
    "Offset ms:": "Czas przesunięcia ms",
    "Content fit strategy:": "Strategia dopasowania zawartości",
    "Default": "Domyślna",
    "Fill": "Wypełnij",
    "Contain": "Zawrzyj",
    "Cover": "Dopasuj",
    "1:1": "1:1",
    "Content position:": "Pozycja zawartości",
    "(for \"Cover\" and \"1:1\" strategies)": "(dotyczy strategii \"Dopasuj\" oraz \"1:1\")",
    "horizontal:": "horyzontalnie",
    "left": "lewa",
    "center": "środek",
    "right": "prawa",
    "vertical:": "pionowo",
    "top": "góra",
    "bottom": "dół",
    "Rotation:": "Rotacja",
    "Set display properties": "Zapisz właściwości wyświetlania",
    "You are removing ": "Usuwasz ",
    "playitems": "elementów",
    " from playlist ": " z playlisty ",
    " from layout ": " z układu ",
    "It will affect also following": "To wpłynie również na następujące",
    "No other playlist will be affected": "Nie wpłynie to na inne playlisty",
    "loading data": "ładowanie danych",
    "You may sort your playlist here, with provided original files. You can use either supplied form, or editor of your preference. Please leave id's intact, they will be used to properly identify media that appear multiple times on playlist.": "Możesz tutaj posortować playlistę, na podstawie dołączonych nazw plików.  Możesz użyć albo tego formularza, albo dowolnego edytora tekstów. Pozostaw id w tej formie, aby można było odróżnić media występujące wielokrotnie w playliście i zachować ich ustawienia.",
    "Reorder form alphabetically": "Ustal kolejność alfabetyczną",
    "Save order": "Zapisz kolejność",
    "Back to list": "Wstecz do listy",
    "Copy Tags": "Skopiuj tagi",
    "Paste Tags": "Wklej tagi",
    "Open in editor": "Otwórz w edytorze",
    "Show usage in right panel ": "Przypadki użycia",
    "Use as Replacement": "Użyj jako zamiennika",
    "in network ": "w sieci ",
    "in playlist ": "w playliście",
    "Assign medium": "Przypisz",
    "Clone medium": "Sklonuj",
    "Delete medium from library": "Usuń z biblioteki",
    "selected media": "wybrane media",
    "Clone media": "Sklonuj",
    "Group into playlist": "Połącz w playlistę",
    "Group into layout": "Połącz w układ",
    "Assign media": "Przypisz",
    "Delete from library": "Usuń z biblioteki",
    "Replace media by name": "Zamień media w oparciu o nazwy",
    "Show Playlog": "Dziennik odtworzeń",
    "Device Playlog": "Dziennik odtworzeń urządzenia",
    "Upgrade Extension": "Zauktualizuj wtyczkę",
    "Edit": "Edytuj",
    "Edit source medium": "Medium bazowe",
    "Display properties": "Właściwości wyświetlania",
    "Player exceptions": "Wyjątki na ekranach",
    "Copy": "Kopiuj",
    "Synchronization listener": "Odbiorca synchronizacji",
    "Paste": "Wklej",
    "Paste synchro listener": "Odbiorca synchronizacji",
    "Clear": "Wyczyść",
    "Synchro listener": "Odbiorca synchronizacji",
    "Extract": "Wyodrębnij",
    "into Playlist": "do playlisty",
    "into Layout": "do układu",
    "Other": "Inne",
    "Remove from playlist": "Usuń z playlisty",
    "Clone playitems": "Sklonuj element",
    "Clone playlist": "Sklonuj playlistę",
    "Clone playlists": "Sklonuj playlisty",
    "Medium usage": "Przypadki użycia",
    "Play only on": "Odtwarzaj tylko na",
    "Do not play on": "Nie odtwarzaj na",
    "Send": "Nadawaj",
    "Listen": "Obieraj",
    "Send synchro marker as soon as playing started": "Nadawaj znacznik synchronizacji wraz z rozpoczęciem odtwarzania",
    "IP": "IP",
    "Message": "Wiadomość",
    "Start playing upon receiving synchronization marker": "Rozpocznij odtwarzanie wraz ze znacznikiem synchronizacji",
    "Choose Marker": "Wybierz znacznik",
    "Send marker": "Nadawaj znacznik",
    "Listen to marker": "Odbieraj znacznik",
    "Create Broadcast marker": "Nadawaj znacznik",
    "Invalid data": "Złe dane",
    "Invalid data. Similar marker name exists in network.": "Złe dane. Podobna nazwa markera istnieje w sieci.",
    "Position:": "Pozycja",
    "Align": "Wyrównanie",
    "mode": "tryb",
    "X": "X",
    "Y": "Y",
    "Dimensions:": "Wymiary:",
    "Reset to": "Zrezetuj do:",
    "layout": "układu",
    "medium": "medium",
    "dimensions": "wymiary",
    "Width": "Szerokość",
    "width px": "szerokość px",
    "Height": "Wysokość",
    "height px": "wysokość px",
    "Incorrect value for ": "Niewłaściwa wartość dla ",
    "Media selected": "Media wybrane",
    "Deselect media": "Usuń wybór mediów",
    "Remove medium from selected": "Usuń medium z wybranych",
    "No tags in Network": "Brak tagów w sieci",
    " Please edit and tag some media to use tag filter": " Wyedytuj i otaguj jakieś media aby użyć filtrowania po tagach",
    " Please edit and tag some devices to use tag filter": " Wyedytuj i otaguj jakieś ekrany aby użyć filtrowania po tagach",
    "all tags required": "wymagaj wszystkich tagów",
    "Switch filter view": "Przełącz widok filtra",
    "Reset filter": "Zresetuj filtr",
    "Select tags to filter media": "Wybierz tagi aby przefiltrować media",
    "You are going to move ": "Zamierzasz przenieść ",
    " and it`s children to production root folder": " oraz zawarte w nim obiekty do folderu głównego",
    "untesting": "odtestowywanie",
    "Gonna upgrade and replace extension: ": "Wtyczka zostanie zaktualizowana i podmieniona",
    "Extensions that can be used for upgrade:": "Wtyczki do aktualizacji",
    "# Networks using": "# Sieci używających",
    "Local": "Lokalna",
    "Global": "Globalna",
    "Replace extension in current network ": "Podmień wtyczkę w bieżącej sieci",
    "Replace extension system-wide ": "Podmień wtyczkę we wszytkich sieciach",
    "Schema is different": "Schema się różni",
    " All configurations of existing media will be reset to default values for new extension": " Wszystkie konfiguracje instniejących w sieci mediów zostaną przywrócone do wartości domyślnych dla nowej wtyczki",
    "Edit client": "Edytuj klienta",
    "Client name": "Nazwa klienta",
    "Password valid days (0 - unlimited)": "Hasła ważne dni (0 - bezterminowo)",
    "Cancel": "Zrezygnuj",
    "Please enter client name": "Wpisz nazwę klienta",
    "Length should be 3 to 255": "Długość musi być między 3 a 255 znaków",
    "Client list": "Lista klientów",
    "Add new client": "Dodaj nowego klienta",
    "Client": "Klient",
    "Networks": "Sieci",
    "Media management": "Zarządzanie mediami",
    "Add extension": "Dodaj wtyczkę",
    "Delete unused extensions": "Usuń nieużywane wtyczki",
    "LEDs": "LEDy",
    "Led Report": "Raport LEDów",
    "Dates": "Daty",
    "Day times": "Godziny dnia",
    "Play period sets": "Zestawy okresów działania",
    "Device management": "Zarządzanie urządzeniami",
    "Add device": "Dodaj urządzenie",
    "Add series of devices": "Dodaj szereg urządzeń",
    "Manage by UUID": "Zarządzaj przez UUID",
    "Organization": "Organizacja",
    "Clients": "Klienci",
    "Access control": "Uprawnienia dostępu",
    "Users": "Użytkownicy",
    "Roles": "Role",
    "Privileges": "Przywileje",
    "NO": "NIE",
    "YES": "TAK",
    "Processing requests": "Przetwarzanie zapytań",
    "Client / Network": "Klient / Sieć",
    "client or network name": "nazwa klienta lub sieci",
    "No such clients found": "nie znaleziono takich klientów",
    "Are you sure you want to move this device to network ": "Czy jesteś pewien, że chcesz przsunąć urządzenie do tej sieci ",
    "Download excel file": "Pobierz plik excel",
    "Show whole network log": "Pokaż dziennik całej sieci",
    "Show:": "Pokaż:",
    "Interval": "Interwał",
    "hours": "godziny",
    "days": "dni",
    "weeks": "tygodnie",
    "months": "miesiące",
    "quarters": "kwartały",
    "years": "lata",
    "media": "media",
    "devices": "urządzenia",
    "Start date": "Data początkowa",
    "Start": "Początek",
    "End date": "Data końcowa",
    "End": "Koniec",
    "Generate": "Wygeneruj",
    "No data collected": "Nie znaleziono danych",
    "Period": "Okres",
    "Medium": "Medium",
    "Device": "Urządzenie",
    "Played items": "Odtworzono elementów",
    "Duration": "Czas trwania",
    "Interrupts": "Przerwań",
    " - deleted": " - usunięto",
    "From:": "Od:",
    "To:": "Do:",
    "Leave blank for infinite": "Puste pole oznacza zawsze",
    "Valid from date": "Ważne od",
    "Valid to date": "Ważne do",
    "Play from date/time": "Odtwarzaj od daty/czasu",
    "Play to date/time": "Odtwarzaj do daty/czasu",
    "short": "krótko",
    "edit": "edytuj",
    "all week": "cały tydzień",
    "Editing day-time restriction - ": "Edycja ustawień czasu w dniach",
    "Choose sets": "Wybierz zestawy",
    "unknown device": "nieznane urządzenie",
    "Device has no location assigned": "Urządzenie nie ma przypisanej żadnej lokalizacji",
    "Please refer to Monitors Tab for locations": "Sprawdź zakładkę Monitory aby zobaczyć lokalizacje",
    "Add device ": "Dodaj urządzenie ",
    "Loading device": "Ładowanie urządzenia",
    "Template": "Szablon",
    "Select": "Wybierz",
    "Deployed": "Zainstalowane u klienta",
    "Test": "Test",
    "Save Device as Template": "Zapisz urządzenie jako szablon",
    "Heartbeat Data": "Dane monitoringu",
    "Device not deployed. Disconnection episodes are registered only for deployed devices.": "Urządzenie nie zainstalowane u klienta. Epizody rozłączeń są rejestrowane tylko dla urządzeń zainstalowanych u klienta.",
    "Requests": "Żądania",
    "Commands": "Komendy",
    "Config Metadata": "Metadane konfiguracji",
    "JSON": "JSON",
    "{}": "{}",
    "Save and send config metadata": "Zapisz i wyślij metadane konfiguracji",
    "sending...": "wysyłanie...",
    "Schedule": "Harmonogram działania",
    "Unable to parse JSON": "Nie można przetworzyć JSONa",
    "Properties": "Właściwości",
    "Monitors": "Monitory",
    "Config was saved": "Konfiguracja została zapisana",
    " However it was not sent to Device, beacuse it has no UUID defined": " Jednakże nie została wysłana do Urządzenia, ponieważ nie ma ono zdefiniowanego UUID",
    " Please refer to Monitors tab": " Sprawdź w zakładce Monitory",
    "Create a number (max. 999) of devices with following rules": "Utwórz pulę (max 999) urządzeń wg. następujących reguł",
    "Name consists of text part and numerical part to start from, separated by underscore eg.:": "Nazwa składa się z części tekstowej oraz części numerycznej (numer początkowy), oddzielonych podkreślnikiem. Np.",
    "Naming convention": "Konwencja nazewnicza",
    "Numeration to start from": "Numeracja początkowa",
    "Number of devices to be created": "Liczba urządzeń do utworzenia",
    "Number off device to add": "Numer urządzenia do dodania",
    "Pad leading zeros": "Dodaj zera poprzedzające",
    "Examples of names of devices that will be created:": "Przykłady nazw urządzeń jakie zostaną utworzone:",
    "Create Device Template from ": "Utwórz Szablon Urządzenia z ",
    "Create Device Template": "Utwórz Szablon Urządzenia",
    "Create device": "Utwórz Urządzenie",
    "Template name": "Nazwa szablonu",
    "Cannot create Device Template": "Nie można utworzyć Szablonu Urządzenia",
    "Cannot send custom requests to this device, beacuse it has no UUID defined, please refer to Monitors tab.": "Nie można wysłać żądania niestandardowego, ponieważ nie posiada ono zdefiniowanego UUID. Wprowadź UUID w zakładce Monitory.",
    "Method": "Polecenie",
    "Status": "Status",
    "Last updated": "Ostatnio zaktualizowane",
    "Select tags for device": "Wybierz tagi dla urządzenia",
    "This device has no tags.": "Urządzenie nie ma tagów.",
    "Click a tag below to assign it to device.": "Kliknij w tagi poniżej, aby przypisać je do urządzenia.",
    "Click to add tag to device": "Kliknij aby dodać tag do urządzenia",
    "Disconnections": "Rozłączenia",
    "Summary": "Podsumowanie",
    "Episodes": "Epizody",
    "Period of last:": "Okras ostatnich:",
    "custom": "niestandardowo",
    "day": "dzień",
    "week": "tydzień",
    "month": "miesiąc",
    "year": "rok",
    "hour": "godzina",
    "Display Only Errors": "Pokaż Tylko Błędy",
    "No disconnections started in period": "W tym czasie nie nastąpiło żadne rozłączenia",
    "From": "Od",
    "To": "Do",
    "Duration (s)": "Czas trwania (s)",
    "Number of disconnects in period": "Liczba rozłączeń w okresie",
    "Disconnected": "Rozłączono",
    "Reconnected": "Ponownie połączono",
    "ongoing": "w trakcie",
    "Device Commands": "Komendy Urządzenia",
    "Body": "Treść",
    "Add Command": "Dodaj Komendę",
    "body": "treść",
    "Add Device command": "Dodaj Komendę Urządzenia",
    "Select location:": "Wybierz lokalizację",
    "Add new device location for network": "Dodaj nową lokalizację w sieci",
    "Address": "Adres",
    "Add location": "Dodaj lokalizację",
    "row": "wiersz",
    "column": "kolumna",
    "width": "szerokość",
    "height": "wysokość",
    "LED": "LED",
    "Device has no monitors defined. If device has some monitors attached, please define them here.": "Urządzenie nie posiada zdefiniowanych monitorów. Jeśli urządzenie posiada podłączone wyświetlacze, zdefiniuj je tutaj",
    "UUID": "UUID",
    "No uuid": "brak UUID",
    "Create one Desktop": "Utwórz jeden Pulpit",
    "Concate monitors and create Video Wall": "Połącz wyświetlaczę w Ścianę Monitorów",
    "or": "lub",
    "Existing desktops will be purged from the database. You will have to edit new desktops UUIDs and re-assign media to them.": "Istniejące ekrany tego urządzenia zostaną usunięte z systemu. Natępnie musisz wprowadzić UUID dla nowych ekranów, oraz ponownie przypisać im media.",
    "No media will be deleted.": "Nie zostaną skasowane żadne media.",
    "Desktops": "Ekrany",
    "uuid": "uuid",
    "location": "lokalizacja",
    "Change desktop": "Zmień ekran",
    "Width (px)": "Szerokość (px)",
    "Height (px)": "Wysokość (px)",
    "Save failed! Another desktop in Wave2 has this UUID already!": "Nie zapisano! Inny ekran w systemie posiada takie samo UUID!",
    "Update desktop": "Zapisz ekran",
    "Update device": "Zapisz urządzenie",
    "Row (A-Z)": "Wiersz (A-Z)",
    "Column (1-10)": "Kolumna (1-10)",
    "choose pitch:": "wybierz plamkę:",
    "Device has no Properties defined": "Urządzenie nie ma zdefiniowanych żadnych właściwości",
    "New property": "Nowa właściwość",
    "Delete property": "Usuń właściwość",
    "Edit property": "Edytuj właściwość",
    "Save Device property": "Zapisz właściwość urządzenia",
    "Add property": "Dodaj właściwość",
    "Add Device property": "Dodaj właściwość urządzenia",
    "This Device has Desktops in different Groups": "To urządzenia posiada ekrany w różnych lokalizacjach",
    " Please set schedule for Groups, not for Device itself": " Zapisz harmonogram działania dla lokalizacji, a nie dla urządzenia",
    "Send update schedule request to all devices in group": "Wyślij żądanie aktualizacji harmonodgramu działania do wszystkich urządzeń w lokalizacji",
    "Group Schedule ": "Harmonogram działania lokalizacji",
    "Send update schedule request to this device": "Wyślij żądanie aktualizacji harmonogramu działania do tego urządzenia",
    "Device Schedule:": "Harmonogram działania urządzenia",
    "Additional times for this device": "Dodatkowe okresy dla tego urządzenia",
    "Requests Failed": "Żadania się nie powiodły",
    "From date: ": "Od daty:",
    "since log-in": "od zalogowania",
    "display already seen": "pokaż wcześniej widziane",
    "Display blocked accounts": "Pokaż zablokowane konta",
    "Sent time": "Czas wysłania",
    "Report time": "Czas raportu",
    "Response": "Odpowiedź",
    "No failed requests": "Brak nieudanych żądań",
    "Edit group": "Edycja lokalizacji",
    "Latitude": "Szerokość geograficzna",
    "Longitude": "Długość  geograficzna",
    "Save group name": "Zapisz nazwę lokalizacji",
    "save group": "Zapisz lokalizację",
    "delete group": "usuń lokalizację",
    "Open Group": "Otwórz lokalizację",
    "Edit group play schedule": "Edytuj harmonogram odtwarzania lokalizacji",
    "Send content update to screen": "Wyśli aktualizację treści do ekranu",
    "Getting Groups": "Pobieranie lokalizacji",
    "Please provide proper name of the Group": "Podaj prawidłową nazwę lokalizacji",
    "Group with this name already exists": "Lokalizacja o tej nazwie już istnieje",
    "Screen Group": "Lokalizacja ekranów",
    "Network Health Report": "Raport stanu sieci",
    "Live Update - Whole Network": "Aktualizuj na bieżąco - Cała sieć",
    "Activity": "Aktywność",
    "Active": "Aktywny",
    "Never Active": "Nigdy nie aktywny",
    "Synchronizations": "Synchronizacje danych",
    "Not sent": "Niewysłane",
    "Stalled": "Bez postępu",
    "Failed": "Nieudane",
    "Free Storage": "Wolna przestrzeń",
    "Good": "Dobre",
    "Danger": "Zagrożenie",
    "Warning": "Ostrzeżenie",
    "Since ": "Od ",
    "Until": "Do ",
    " Wrong range": " Zły zakres",
    " Please pick a valid range": " Wprowadź właściwy zakres",
    "Ongoing disconnections": "Aktualne rozłączenia",
    "No disconnections that started in given period.": "Nie było rozłączeń w zadanym okresie.",
    "Disconnections that started and ended in given period:": "Rozłączenia które się rozpoczęły i zakończyły w zadanym okresie",
    "There are no stalled or failed downloads over the past week.": "Nie było zatrzymanych lub nieudanych pobierań zawartości w minionyum tygodniu",
    "Stalled downloads (contact lost during content update):": "Zatrzymane pobierania zawartości (kontakt utracono podczas pobierania zawartości)",
    "Device - Screen": "Urządzenie - Ekran",
    "Started": "Rozpoczęta",
    "Last progress update": "Ostatnia aktualizacja postępu",
    "Progress": "Postęp",
    "Content Id": "Id zawartości",
    "Content Id in last reported HB": "Id zawartości w ostatniej aktualizacji monitoringu",
    "Failed downloads (last 30):": "Nieudane synchronizacje zawartości (ostatnich 30)",
    "Warning limit GB ": "Limit ostrzeżenia GB",
    "Danger limit GB": "Limit niebezpieczeństwa GB",
    "Devices with limited free disk space:": "Urządzenia z małą ilością wolnej przestrzeni dyskowej:",
    "Free Disk GB": "Wolna przestrzeń dyskowa GB",
    "All devices have > ": "Wszystkie urządzenia mają > ",
    "GB of free storage": "GB wolnej przestrzeni dyskowej",
    "Today": "Dzisiaj",
    "Yesterday": "Wczoraj",
    "A week ago": "Tydzień temu",
    "30 days ago": "30 dni temu",
    "A year ago": "Rok temi",
    "Unknown": "Nieznany",
    "Network": "Sieć",
    "Display": "Ekran",
    "Pitch": "Plamka",
    "Width px": "Szerokość px",
    "Height px": "Wysokość px",
    "# of panels in width": "# paneli w szerokości",
    "# of panels in height": "# paneli w wysokości",
    "Width mm": "Szerokość mm",
    "Height mm": "Wysokość mm",
    "Area sq. meters": "Powierzchnia metrów kw.",
    "Players waiting for content approval": "Ekrany oczekujące na akceptację zawartości",
    "Players synchronizing content": "Ekrany synchronizujące zawartość",
    "Heartbeat status": "Status raportu monitoringu",
    "Screenshot": "Zrzut ekranu",
    "No screenshot yet": "Nie ma jeszcze zrzutu ekranu",
    "Edit device": "Edycja urządzenia",
    "Edit monitor": "Edycja monitora",
    "ago": "temu",
    "Refresh with big screenshot": "Odświerz z dużym zrzutem ekranu",
    "Preparing Players": "Przygotowywanie Ekranów",
    "Screen list": "Lista ekranów",
    "Locations": "Lokalizacje",
    "Group -": "Lokalizacja -",
    "Edit location": "Edycja lokalizacji",
    "Content": "Zawartość",
    "Restart renderer": "Restartuj Renderer",
    "Restart core": "Restartuj Rdzeń aplikacji",
    "Restart OS": "Restartuj OS",
    "Clear content": "Wyczyść zawartość",
    "Delete location": "Usuń lokalizację",
    "Copy tags": "Tagi",
    "Copy time restrictions": "Ograniczenia czasowe",
    "Paste tags": "Tagi",
    "Paste time restrictions": "Ograniczenia czasowe",
    "Update": "Zaktualizuj",
    "Restart": "Uruchom ponownie",
    "Set location": "Zapisz lokalizację",
    "Remove from ": "Usuń z ",
    "UUID / Name": "UUID / Nazwa",
    "UUID / Name / Network": "UUID / Nazwa / Sieć",
    "Last Modification": "Ostatnia Modyfikacja",
    "Action": "Akcja",
    "Change network": "Zmień sieć",
    "Deactivate device": "Deaktywuj urządzenie",
    "Reset secret": "Zresetuj hasło urządzenia",
    "Enter network": "Wejdź do sieci",
    "Move device to Network": "Przenieś urządzenie do Sieci",
    "No desktops found": "Nie znaleziono ekranów",
    "Are you sure you want to perform ": "Czy jesteś pewien, że chcesz wykonać ",
    " on ": " na ",
    "selected devices": "wybranych urządzeniach",
    "updateContents": "'aktualizacja treści'",
    "restartRenderers": "'restartuj renderer'",
    "restartDevices": "'restartuj urządzenie'",
    "restartDevicesCore": "'restartuj rdzeń aplikacji'",
    "restartDevicesOS": "'restartuj urządzęnie'",
    "updateSchedules": "'zaktualizuj harmonogram działania'",
    "pasteTimeRestrictions": "'wklej harmonogram działania'",
    "pasteTags": "'wklej tagi'",
    "clearTags": "'wyczyść tagi'",
    "clearTimeRestrictions": "'wyczyść harmonogram działania'",
    "purgeContents": "'wyczyść zawartość'",
    "on device UUID:": "dla urządzenia o UUID",
    "Screens selected": "Wybrane ekrany",
    "Deselect screens": "Odznacz ekrany",
    "Deselect screen": "Odznacz ekran",
    "Custom Method": "Metoda niestandardowa",
    "Re-send last Update Content": "Wyślij ponownie ostatnie polecenie aktualizacji zawartości",
    "Cancel Content Update": "Zatrzymaj aktualizację zawartości",
    "Update Player Schedule": "Zaktualizuj harmonogram działania",
    "Make Screenshot": "Prześlij zrzut ekranu",
    "Restart Renderer": "Zrestartuj Renderer",
    "Restart Core": "Zrestartuj Rdzeń",
    "Arguments": "Argumenty",
    "send": "wyślij",
    "Error": "Błąd",
    " Argument must be a valid JSON": " Argument musi być poprawnym wyrażeniem JSON",
    "Cannot send on-demand request to device beacause first desktop has no uuid specified": "Nie można wysłać żądania na życzenie ponieważ pierwszy ekran urządzenia nie ma ustalone UUID",
    "Select tags to filter devices": "Wybierz tagi aby przefiltrować urządzenia",
    " synchronizations ": " pobierania zawartości",
    "in progress": "w trakcie",
    "Stop all": "Zatrzymaj wszystkie",
    "Deleted Device?": "Urządzenie usunięte?",
    "Stop content download": "Zatrzymaj synchronizację zawartości",
    "Device content synchronizations": "Synchronizacje zawartości",
    "Synchronizations to start": "Synchronizacje zawartości oczekujące na start",
    "Synchronizations in progress": "Synchronizacje zawartości w trakcie",
    "Synchronizations finished": "Synchronizacje zawartości zakończone",
    "Loading content synchronization data": "Ładowanie danych o synchronizacja zawartości",
    "desktops can be synchronized:": "ekrany których zawartości mogą zostać zsynchronizowane:",
    "Synchronize all": "Zsynchronizuj wszystkie",
    "Synchronize mine": "Zsynchronizuj moje",
    "Start later": "Zacznij później",
    "Start content download": "Rozpocznij synchronizację zawartości",
    "ERROR 400!": "BŁĄD 400!",
    "Incorrect request": "Nieprawidłowe żądanie",
    "OK": "OK",
    "ERROR 403!": "BŁĄD 403!",
    "You do not have sufficient right to perform this action": "Nie masz wystarczających uprawnień, aby przeprowadzić tę operację",
    "ERROR 404!": "BŁĄD 404!",
    "Object not found": "Nie znaleziono",
    " Perhaps somebody else removed it?": " Może ktoś już usunął obiekt?",
    "ERROR 500!": "BŁĄD 500!",
    "Server error": "Błąd serwera",
    "Cannot assign items": "Nie można przypisać elementów",
    "ERROR !": "BŁĄD !",
    "You were disconnected from server": "Utracono połączenie z serwerem",
    "Trying to reconnect": "Próba ponownego połączenia",
    "Go to Log-in screen": "Przejdź do ekranu logowania",
    "Media conversions in progress": "Konwersje mediów w toku",
    "Original file name:": "Nazwa oryginalnego pliku",
    "Original file hash:": "Suma kontrolna oryginalnego pliku",
    "Current file hash:": "Suma kontrolna aktualnego pliku",
    "Original file size:": "Wielkość oryginalnego pliku",
    "Current file size:": "Wielkość aktualnego pliku",
    "Original file MIME:": "Typ MIME oryginalnego pliku",
    "Created at:": "Utworzono:",
    "Updated at:": "Zmodyfikowano:",
    "ok": "ok",
    "cancel": "zrezygnuj",
    "select file(s) to upload": "wybierz plik(i) do wgrania",
    "Convert mp4 anyway?": "I tak skonwetować mp4?",
    "Some errors occured during upload": "Wystąpiły błedy podczas wgrywania",
    "clear": "wyczyść",
    "remove from upload": "usuń z listy do wgrania",
    "file too big": "plik zbyt duży",
    "processing": "przetwarzanie",
    "ready": "gotowe",
    "success": "sukces",
    "pending": "w kolejce",
    "delivered": "dostarczone",
    "failed": "nieudane",
    "start date and time": "data i czas początku",
    "end date and time": "data i czas końca",
    "Play Period Set list": "Lista zestawów okresów działania",
    // "Holiday Set list": "Lista zestawów świąt",
    "Set": "Zestaw",
    "# Periods": "# Okresów",
    "Edit datetime set": "Edycja zestawu świąt",
    "Delete datetime set": "Usuń zestaw świąt",
    "Live Mode": "Aktualizacje na żywo",
    "Heartbeat": "Monitoring",
    "Content Update Progress": "Postęp pobierania treści",
    "Content Pending": "Treści do aktualizacji",
    "Failed Requests": "Nieudane żądania",
    "Media Convertions": "Konwersje mediów",
    "Screenshots": "Zrzuty ekranu",
    "Library updates": "Aktualizacje biblioteki",
    "Send pending changes to players": "Wyślij zmiany na ekrany",
    "Synchronize selected screens": "Wyślij do wybranych",
    "Choose language": "Wybierz język",
    "Logout": "Wyloguj",
    "Preferences": "Preferencje",
    "Logged in users": "Zalogowani użytkownicy",
    "Advanced menu": "Menu zaawansowane",
    "Media List": "Lista mediów",
    "Ctrl+Alt+D to switch context": "Ctrl+Alt+D aby zmienić kontekst",
    "Server slow down or malfunction detected": "Wykryto spowolnienie lub awarię serwera",
    "You may experience some inconvenience": "Może się to wiązać z utrudnionym korzystaniem z serwisu",
    "Home": "Dom",
    "Pick extension": "Wybierz wtyczkę",
    "Local extensions": "Lokalne wtyczki",
    "Global extensions": "Globalne wtyczki",
    "Add to network": "Dodaj do sieci",
    "Add to network:": "Dodaj do sieci:",
    "Media": "Media",
    "Layout": "Układ",
    "Folder": "Katalog",
    "Extension/Widget": "Wtyczka",
    "HTML page": "Strona HTML",
    "Screens Group": "Lokalizacja",
    "Assign": "Przypisz",
    "to playlists / layouts": "do układów / playlist",
    "to screens": "do ekranów",
    "Clone": "Sklonuj",
    "Playitems": "Elementy",
    "Into": "Do",
    "Number of copies": "Liczba kopii",
    "Copy other restrictions": "Skopiuj pozostałe restrykcje",
    "Media to be deleted": "Media do usunięcia",
    "Delete": "Usuń",
    "Please select one item to see which desktops and playlists will be affected": "Wybierz jeden element aby zobaczyć na jakie ekrany i playlisty wpłynie",
    "Please select some media on the left to delete them": "Wybierz jakieś media z lewej aby je skasować",
    " You will be informed about consequences prior to delete": " Zostaniesz poinformowany o konsekwencjach na ekranach przed usunięciem",
    "Extract into": "Wyodrębnij do",
    "Playitems Extracted": "Elementów Wyodrębnionych",
    "Playlist name": "Nazwa playlisty",
    "Layout name": "Nazwa układu",
    "Add screens": "Dodaj ekrany",
    "Add": "Dodaj",
    "adding": "dodawanie",
    "to location": "do lokalizacji",
    "Add new device location": "Dodaj nową lokalizację urządzeń",
    "Media Assigned": "Media przypisane",
    "Cannot replace - loop detected": "Nie można zamienić - wykryto pętlę",
    "Replace all occurences of a Medium in network": "Zamień wszystkie wystąpienia medium w sieci",
    "New Medium": "Nowe medium",
    "replace": "Zamień",
    "Old medium": "Stare medium",
    "Replace Medium in Playlist/Layout ": "Zamień medium w Playliście/Układzie",
    " at position ": " w pozycji",
    "Old Medium": "Stare medium",
    "In order to enable \"replace\", you have to ": "Żeby dokonać \"zamiany\", musisz ",
    "wybrać nowe medium w Bibliotece z lewej, oraz wybrać element Playlisty / Układu z prawej": "",
    "Name-based media replacement in network": "Oparte na nazwie zamiany mediów w sieci",
    "replacing": "Zamienianie",
    "Replace": "Zamień",
    "Multiple media are candidates for substitusion of same medium": "Wiele nowych mediów jest kandydatami do podmiany medium",
    " Probably something is wrong with media naming": " Prawdopodobnie coś jest nie tak z nazwami mediów",
    "Select/deselect all": "Zaznacz/Odznacz wszystkie",
    "Only in current playlist": "Tylko w aktualnym Playliście / Układzie",
    "Limit playlists": "Ogranicz do Playlist / Układów",
    "playlists selected": "wybranych Playlist / Układów",
    "Are you sure you want to make replacents?": "Czy jesteś pewnien, że chcesz dokonać zamiany?",
    "add": "dodaj",
    "assign": "przypisz",
    "Layers": "Warstwy",
    "Apply from:": "Zastosuj z:",
    "Position on layout:": "Pozycja na układzie:",
    "Content fit:": "Dopasowanie zawartości:",
    "Network list": "Lista sieci",
    "Conversion profile": "Profil konwersji",
    "Banned": "Zablokowana",
    "Edit network": "Edycja sieci",
    "Select network": "Wybierz sieć",
    "Convert all images to .mp4:": "Konwertuj wszystkie obrazy do .mp4:",
    "convert to .mp4": "konwertuj do .mp4",
    "use images": "użyj obrazów",
    "Media Duplicates:": "Duplikaty mediów",
    "Duplicates": "Duplikaty",
    "allow": "zezwól",
    "disallow": "zabroń",
    "Max upload file size (MB)": "Maksymalny rozmiar wgrywanego pliku (MB)",
    "Upload disabled for network": "Wgrywanie wyłączone dla sieci",
    "Type a number": "Wprowadź liczbę",
    "Test functionality:": "Finkcjonalność testowa",
    "Tag-dependancy play functionality:": "Funkcjonalność odtwarzania zależnego od tagów",
    "Enabled": "Włączona",
    "Heartbeat interval (s)": "Interwał przysyłania danych monitoringowych",
    "Network active": "Sieć aktywna",
    "Deep Nesting:": "Głębokie zagnieżdżenia:",
    "Please enter network name": "Wprowadź nazwę sieci",
    "Please select client": "Wybierz klienta",
    "Privileges list": "Lista przywilejów",
    "Add new privileges": "Dodaj nowe przywileje",
    "Entity": "Encja",
    "Edit privilege": "Edycja przywileju",
    "Please enter privilege entity": "Wprowadź encję przywileju",
    "Please enter privilege action": "Wprowadź akcję przywileju",
    "Please select method": "Wybierz metodę",
    "Role list": "Lista ról",
    "Add new role": "Dodaj nową rolę",
    "Role": "Rola",
    "Privileges #": "# przywilejów",
    "Role name": "Nazwa Roli",
    "Please enter role name": "Wprowadź nazwę roli",
    "Updatable screens": "Ekrany do aktualizacji zawartości",
    "Content synchronizations in progress": "Aktualizacje zawartości w toku",
    "Failed requests": "Nieudane żądania",
    "Selected screens": "Wybrane ekrany",
    "devices during synchronization": "urządzenia w trakcie aktualizacji zawartości",
    "Device reported an Error": "Urządzenie zgłosiło Błąd",
    "Selected media": "Wybrane media",
    "Files uploading": "Pliki wgrywane",
    "Media in conversion": "Media w konwersji",
    "Copied tags": "Skopiowane tagi",
    "Wrong link or link expired": "Zły link lub link wygasł",
    "Password change": "Zmiana hasła",
    "Requirements: between 5 to 15 characters, contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character": "Wymagania: między 5 a 15 znaków, minimum jedna litera mała, jednak wielka, jedna cyfra, oraz jeden znak specjalny",
    "Enter password": "Wprowadź hasło",
    "Password is NOT valid": "Hasło nieprawidłowe",
    "Password is valid": "Hasło prawidłowe",
    "Password valid days": "Ważność hasła dni",
    "Confirm password": "Potwierdź hasło",
    "Save new password and log-in": "Zapisz nowe hasło i się zaloguj",
    "Password has to meet following requirements:": "Hasło musi spełniać następujące wymagania:",
    "at least 8 characters in length,": "minimum 8 znaków",
    "contain at least one upper-case character,": "minimum jedna duża litera",
    "contain at least one lower-case character,": "minimum jedna mała litera",
    "contain at least one digit,": "minum jedna cyfra",
    "contain at least one special character": "minimum jeden znak specjalny",
    "User list": "Lista użytkowników",
    "Add new user account": "Dodaj nowe konto użytkownika",
    "Email": "Email",
    "Nick": "Pseudonim",
    "Edit user": "Edycja użytkownika",
    "Your browser window is too small": "Obszar roboczy przeglądarki jest zbyt mały",
    " You may experience inconvenience using WAVE2": " Może to wpływać na korzystanie z WAVE2",
    "Minimum recommended resolution is 1768 x 852": "Minimalna rodzielczość zalecana to 1768 x 852",
    "Your resolution is ": "Twoja rozdzielczość jest ",
    "An error occured:": "Wystapił błąd:",
    "Wrong email format": "Zły format adresu email",
    "Enter login email": "Wprowadź email jako nazwę użytkownika",
    "Minimum password length is 4 characters": "",
    "Email address": "Adres email",
    "Password": "Hasło",
    "connecting to server": "łączenie z serwerem",
    "Logging in": "Logowanie",
    "Login": "Zaloguj",
    "Forgot your password?": "Zapomniałeś hasła?",
    "Wrong creditientials": "Złe dane logowania",
    "Check email and password and try again": "Sprawdź email i hasło i spróbuj ponownie",
    "Your account / network is blocked": "Twoje konto lub cała sieć są zablokowane",
    " Please contact administrator": " Skontaktuj się z administratorem",
    "Password recovery": "Odzyskiwanie hasła",
    "Password recovery of": "Odzyskiwanie hasła dla",
    "password": "hasło",
    "Enter your email address (same as your login)": "Wprowadź swój adres email (taki sam jak nazwa użytkownika używana do logowania)",
    " A message containing further instructions will be sent to that address": " Dodatkowe instrukcje zostaną wysłane na ten sam adres",
    "Unable to recover password": "Nie można odzyskać hasła",
    "Email not found": "Email nie znaleziony",
    "Message was sent": "Wiadomość wysłana",
    " Check your mailbox for further instructions": " Sprawdź skrzynkę odebranych wiadomości i odbierz email z dalszymi instrukcjami",
    "Change client will clean actual networks": "Zmiana klienta spowoduje wyczyszczenie sieci do których jest dostęp",
    "Client Networks": "Sieci Klienta",
    "Retype password": "Wprowadź hasło ponownie",
    "Send reset password link": "Wyślij link z resetem hasła",
    "Send link": "Wyślij link",
    "Generate new password": "Wygeneruj nowe hasło",
    "Copy password to clipboard": "Skpiuj hasło do schowka",
    "Account active": "Konto aktywne",
    "Test user:": "Użytkownik testowy:",
    "Please input the password": "Wprowadź hasło",
    "Please input the password again": "Wprowadź hasło ponownie",
    "Two inputs don\\'t match!": "Hasła nie są takie same",
    "Please enter nick name": "Wprowadź pseudonim",
    "Please enter email": "Wprowadź adres email",
    "Email should be valid address": "Email musi mieć właściwy format",
    "Please select a client": "Wybierz klienta",
    "Please select assigned roles": "Wybierz role dla użytkownika",
    "Please select assigned network": "Wybiesz sieci dla użytkownika",
    "Trying to reconnect...": "Próba ponownego połączenia...",
    "ip": "adres IP",
    "uptime": "Czas od uruchomienia",
    "cpu": "Obciążenie procesora %",
    "freeMem": "Wolna pamięć",
    "freeDisk": "Wolny dysk",
    "runtimeVersion": "Wersja runtime",
    "contentDownloadId": "Id ostatniego pobrania treści",
    "Timestamp": "Czas przysłania raportu",
    "platform": "System operacyjny",
    "platformVersion": "Wersja systemu",
    "nodeVersion": "Wersja nodejs",
    "renderer": "Renderer",
    "appUptime": "Czas od uruchomienia aplikacji",
    "mac": "Adres mac karty sieciowej",
    "standby": "Tryb standby włączony",
    "MEDIUM_COPY_CREATED": "UTWORZONO KOPIĘ",
    "Load": "Załaduj",
    "Usage": "Użycie",
    "Replace by name": "Zastąp na podstawie nazwy",
    "Clone simple": "Proste klonowanie",
    "Resend Last Content": "Wyślij ponownie treść",
    "Deployed players": "Ekrany zainstalowane u klienta",
    "In progress": "W trakcie",
    "Recently finished": "Ostatnio zakończone",
    "Clone recursive": "Klonowanie rekursywne",
    "Please, provide suffix for copies of container media that will be created.": "Podaj sufiks nazw który zostanie dodany do utworzonych kopii mediów kontenerowych.",
    "Container medium will be duplicated, along with all it's container media, and all copies placed along with original in library. Non-container media will be assigned to newly created playlist, but will not be duplicated. Time restrictions and display properties will be preserved.": "Media kontenerowe zostaną zduplikowane i ich kopie umieszczone w odpowiednich katalogach madiów źródłowych. Media niekontenerowe zostaną do nich przypisane tak jak w oryginałach. Ustawienia elementów zostaną zachowane.",
    "cloning...": "klonowanie...",
    "Show file conversion queue": "Kolejka konwersji wideo",
    "Tree view": "Widok drzewa",
    "show thumbs": "pokaż miniaturki",
    "hide thumbs": "ukryj miniaturki",
    "show restrictions": "pokaż restrykcje",
    "hide restrictions": "ukryj restrykcje",
    "hide non-container media": "ukryj media niekontenerowe",
    "show non-container media": "pokaż media niekontenerowe",
    "remove indentation": "ukryj wcięcia",
    "indent": "pokaż wcięcia",
    "hide media not fulfilling restrictions": "ukryj media niespełniające restrykcji na zadany moment",
    "show media not fulfilling restrictions": "pokaż media niespełniające restrykcji na zadany moment",
    "Screen Group View": "Widok grupy ekranów",
    "step in minutes": "krok w minutach",
    "Too many appearances": "Zbyt wiele przypadków użycia",
    "Click to expand list": "Kliknij aby pokazać listę",
    "appearances": "przypadki użycia",
    "All playitems": "Wszystkie elementy",
    "LOADING NETWORK DATA": "ŁADOWANIE DANYCH SIECI",
    "...LEAVING NETWORK": "...OPUSZCZANIE SIECI",
    "Loading root folder...": "Ładowanie katalogu głównego biblioteki...",
    "Loading media...": "Ładowanie mediów...",
    "Analyzing media...": "Analizowanie mediów...",
    "Loading devices...": "Ładowanie ekranów...",
    "Loading device list...": "Ładowanie listy urządzeń...",
    "Loading device groups...": "Ładowanie grup urządzeń...",
    "Loading pending content...": "Ładowanie urządzeń oczekujących na treści...",
    "Loading content downloads...": "Ładowanie urządzeń pobierających treści...",
    "Loading device tags...": "Ładowanie tagów urządzeń...",
    "Limit playlists/layouts in which": "Ogranicz playlisty/układy w których podmiana",
    "will be replaced. Leave blank to replace all occurrences in all playlists/layouts.": "zostanie przeprowadzona. Pozostaw puste, aby podmienić we wszystkich playlistach i układach",
    "Last success": "Ostatnie powodzenie",
    "Create New Content Edition": "Utwórz nowe wydanie treści",
    "Create new content edition": "Utwórz nowe wydanie treści",
    "All local playlists will be copied, along with their content. Created playlists will be renamed according to naming rules, and placed in local playlists, with time restriction set here.": "Wszystkie lokalne playlisty zostaną skopiowane wraz z ich zawartością. Utworzone playlisty zostaną przemianowane zgodnie z regułami nazewnictwa i umieszczone w lokalnych playlistach z ustawionym ograniczeniem czasowym.",
    "Operation may take long time, depending on size of your network and content complexity. You can proceed to work with Wave, created content will be visible when process is done. You may follow progress below at any time, by reopening this form.": "Operacja może trwać długo, w zależności od rozmiaru twojej sieci i złożoności zawartości. Możesz kontynuować pracę z Wave, utworzona zawartość będzie widoczna po zakończeniu procesu. Możesz śledzić postęp poniżej w dowolnym momencie, przez ponowne otworzenie tego formularza.",
    "Please provide rename rules for copies of container media that will be created. You must provide at least 3 characters for both inputs. Media not fulfilling the \"search for\" input will be omitted.": "Proszę podać reguły przemianowywania kopii zawartości mediów, które zostaną utworzone. Musisz podać co najmniej 3 znaki dla obu wartości. Media, które nie spełniają kryterium \"szukaj w\" zostaną pominięte.",
    "Choose moment screens will switch to playing new content. Current content will have \"stop\" date, and new content \"start\" date adjusted accordingly.": "Wybierz moment, w którym ekrany przełączą się na odtwarzanie nowej zawartości. Obecna zawartość będzie mieć \"datę zakończenia\", a nowa zawartość \"datę rozpoczęcia\" odpowiednio ustawioną.",
    "search for": "poszukiwany ciąg znaków",
    "replace with": "zastępujący ciąg znaków",
    "Moment of content change": "Moment zmiany treści",
    "Content creation is in progress. You cannot start content creation, until current is done.": "Tworzenie nowej treści jest w toku. Nie możesz uruchomić nowego procesu, dopóki aktualny się nie skończy.",
    "Done ": "Wykonano ",
    "of": " z ",
    " of ": "  z  ",
    "Path": "Ścieżka",
    "Your configuration:": "Twoja konfiguracja:",
    "Default Configuration:": "Domyślna konfiguracja:",
    "Set your configuration": "Ustaw swoją konfigurację",
    "(overriden by playitem)": "(nadpisana w playitemie)",
    "for": "dla",
    "Require matching device tags to play:": "Wymagane tagi playera do odtwarzania:",
    "none": "żadne",
    "any": "jakiekolwiek",
    "all": "wszystkie",
    "Detailed view": "Widok szczegółowy",
    "min 4 chars": "min 4 znaki",
    "Delayed": "Opóźnienie",
    "Start at": "Rozpocznij",
    ...elementLocalePl
  },
  es: {
    'Create': 'crear',
    'Cancel': 'cancelar',
    'email': 'email',
    'username': 'nombre de usuario',
    'password': 'contraseña',
    'reset': 'resetord',
    'submit': 'enviar',
    'Name': 'Nombre',
    'Thumbnail': 'Miniatura',
    'File': 'Expediente',
    'Content': 'Contenido',
    'Operations': 'Operaciones',
    'No data': 'Sin datos',
    'Original file name:': 'Nombre del archivo original:',
    'Original file hash:': 'Hash de archivo original:',
    'Original file size:': 'Tamaño del archivo original:',
    'Original file MIME:': 'Archivo original MIME:',
    'Created at:': 'Creado en:',
    'Updated at:': 'Actualizado en:',

    'User list': 'Lista de usuarios',
    'Nick': 'Nazwisko',
    'Email': 'Email',
    'Password': 'Hasło',
    'Retype password': 'Hasło powtórnie',
    'Client': 'Klient',
    'Roles': 'Rola',
    'Edit user': 'Edycja użytkownika',
    'Add new user account': 'Dodaj nowe konto użytkownika',
    'Edit user account': 'Edytuj konto użytkownika',
    'Delete user account': 'Usuń konto użytkownika',
    'Please enter nick name': 'Proszę wprowadzić nazwę użytkownika',
    'Length should be 3 to 255': 'Długość powinna być pomiędzy 3 a 255',
    'Please enter email': 'Proszę wprowadzić email',
    'Email should be valid address': 'Email musi być prawidłowym adresem',
    'Please select a client': 'Proszę wskazać klienta',
    'Please select assigned roles': 'Proszę wskazać rolę w systemie',
    'Please input the password': 'Proszę wprowadzić hasło',
    'Please input the password again': 'Proszę ponownie wprowadzić hasło',
    'Two inputs don\'t match!': 'Wprowadzone dane nie są takie same',
    'shortMonday': 'Po',
    'shortTuesday': 'Wt',
    'shortWednesday': 'Śr',
    'shortThursday': 'Cz',
    'shortFriday': 'Pi',
    'shortSaturday': 'So',
    'shortSunday': 'Nd',
    'shortestMonday': 'P',
    'shortestTuesday': 'W',
    'shortestWednesday': 'Ś',
    'shortestThursday': 'C',
    'shortestFriday': 'P',
    'shortestSaturday': 'S',
    'shortestSunday': 'N',
    ...elementLocaleEs
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/messages.js